<template>
  <div class="main">
    <!--<img alt="Vue logo" src="../assets/logo.png">-->
    <transition appear name="inviteAnimate">
      <Invite/>
    </transition>
    <!--<Testcomponent/>-->
  </div>
</template>

<script>

// @ is an alias to /src
import Invite from '@/components/Invite.vue';
// import Splash from '@/components/Splash.vue';
// import Testcomponent from '@/components/Testcomponent.vue';

export default {
  name: 'home',
  components: {
    Invite
    // Splash /* , */
    // Testcomponent
    // man kan även skriva 'new-component-name' : Testcomponent om man vill använda ett nytt namn och få en garanterat unik selector till sin template
  },
  data: function () {
    return {
      // personname: 'Max'
    };
  }
};
</script>

